<template>
  <div v-show="show" class="bc active protocol-bc">
    <div class="dialog">
      <div v-if="category" class="protocol">
        <div class="protocol-header">
          <h5>{{ category.Title ? category.Title : "" }}</h5>
        </div>
        <div class="protocol-main">
          <article v-if="category.DetailDesc" v-html="category.DetailDesc"/>
        </div>
      </div>
      <div class="footer">
        <button class="btn-cancel" @click="close">取消</button>
        <button class="btn-main btn-next" @click="confirm">确定</button>
      </div>
    </div>


  </div>
</template>

<script>
export default {
  name: "categoryContentDialog",
  props: {
    show: {
      type: Boolean,
      required: true
    },
    categoryCode: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      category: {
        Title: "",
        DetailDesc: ""
      }
    }
  },
  model: {
    prop: "show",
    event: "change"
  },
  watch: {
    show(newVal, oldVal) {
      if (newVal) {
        this.getCategory()
      }
    }
  },
  methods: {
    getCategory() {
      this.$fetch('/api/CmsCategory/GetCategoryInfo', {cateNo: this.categoryCode}).then(result => {
        this.category = result
      })
    },
    confirm() {
      this.$emit("confirm")
      this.close()
    },
    close() {
      this.$emit("update:show", false)
    }
  }
}
</script>

<style scoped lang="less">
.bc {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  margin: auto;
  opacity: 0;
  transition: all 0.2s;
  z-index: -1;

  &.active {
    z-index: 1;
    opacity: 1;
  }
}

.dialog {
  background: #fff;
  padding: 10px;
  overflow: unset;

  .footer {
    border-top: 1px solid #e5e5e5;
    padding-top: 10px;
    display: flex;
    justify-content: flex-end;

    .btn-cancel {
      background: #fff;
      border: 1px solid #e5e5e5;
      width: 70px;
      border-radius: 0.08rem;
      font-size: 0.28rem;
      margin-right: 10px;

      &:active {
        background: #fff - 10%;
      }
    }

    .btn-next {
      width: 70px;
      margin: 0;
    }
  }
}

.protocol-bc {
  padding: 24 / @rem-size;

  .protocol {
    width: 100%;
    background: #fff;
    height: auto;
    max-height: 100%;
    padding-bottom: 25 / @rem-size;

    .protocol-header {
      padding: 32 / @rem-size 0 25 / @rem-size;
      border-bottom: 1px solid #e5e5e5;

      h5 {
        padding: 0;
        margin: 0;
        font-size: 36 / @rem-size;
        color: #333;
        text-align: center;
        font-weight: normal;
      }

      span.subtitle {
        color: #999;
        font-size: 24 / @rem-size;
        display: block;
        margin-top: 20 / @rem-size;
        text-align: center;
      }
    }

    .protocol-main {
      overflow-y: scroll;
      max-height: 500px;
      padding-top: 20 / @rem-size;
      padding-bottom: 40 / @rem-size;

      span {
        font-size: 30 / @rem-size;
      }

      p {
        padding: 0 18 / @rem-size;
        text-align: left;
        font-size: 28 / @rem-size;
        color: #333333;
        line-height: 40 / @rem-size;
      }

      .account-info {
        font-size: 28 / @rem-size;
        color: #333333;
        line-height: 40 / @rem-size;
        padding: 0 18 / @rem-size;

        span {
          text-align: left;
          font-size: 28 / @rem-size;
          color: #333333;
          line-height: 40 / @rem-size;
        }

        .info {
          span {
            float: left;
            max-width: 520 / @rem-size;
          }
        }
      }
    }

    .protocol-footer {
      padding: 0 18 / @rem-size;
      margin-top: 30 / @rem-size;

      span {
        text-align: right;
        line-height: 42 / @rem-size;
      }
    }
  }
}

.btn-next {
  display: block;
  width: 360 / @rem-size;
  height: 80 / @rem-size;
  border-radius: 8 / @rem-size;
  margin: 0 auto;
  color: #fff;
  font-size: 28 / @rem-size;

  &:active {
    background: #005fd5 - 10%;
  }
}

</style>
